import { render } from "./MaterialDetails.vue?vue&type=template&id=6b39a6ea&scoped=true"
import script from "./MaterialDetails.vue?vue&type=script&lang=js"
export * from "./MaterialDetails.vue?vue&type=script&lang=js"

import "./MaterialDetails.vue?vue&type=style&index=0&id=6b39a6ea&lang=scss&scoped=true"
import "./MaterialDetails.vue?vue&type=style&index=1&id=6b39a6ea&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b39a6ea"]])

export default __exports__